<template>
  <div class="header flexaj">
    <div class="top flexaj">
      <div class="container flexsb">
        <div class="left flexa">
          <div class="mobile-globalcash flexa" v-if="isShow">
            <img
              src="@/assets/images/home/tel.png"
              width="16"
              height="16"
              alt
              style="margin-right:2px;"
            />
            <span
              class="pointer-underline"
              @mouseenter="showAppDownload"
              @mouseleave="hideAppDownload"
            >{{$t("header.globalApp")}}</span>
            <div
              class="appDownload-box flexsa flexa"
              @mouseenter="isInnerDownload=true"
              @mouseleave="isAppDownLoadShow=false;isInnerDownload=false"
              v-if="isAppDownLoadShow"
            >
              <div class="left flexc flexsa" style="height: 100%;">
                <a
                  href="https://www.globalcash.hk/applicationManage/open/appDown.do?appid=1"
                  target="_blank"
                >
                  <img src="@/assets/images/home/android.jpg" alt title="点击下载" />
                </a>
                <a href="https://itunes.apple.com/hk/app/id682185259" target="_blank">
                  <img src="@/assets/images/home/iphone.jpg" alt title="点击下载" />
                </a>
              </div>
              <div class="right flexc flexa">
                <img src="@/assets/images/home/globalcash_downApp.png" alt />
                <div class="flexc p-666 flexa">
                  <span>{{$t("loginBox.scanToDownload")}}</span>
                  <span>（支持Android、iOS）</span>
                </div>
              </div>
            </div>
          </div>
          <span>{{$t("header.focus")}}：</span>
          <img
            style="margin-left:10px;"
            src="@/assets/images/home/weixin.png"
            width="20"
            height="20"
            alt
            @mouseenter="isWxShow=true"
            @mouseleave="isWxShow=false"
          />
          <a href="https://weibo.com/epaylinks2011" target="_blank" class="flexaj">
            <img
              src="@/assets/images/home/weibao.png"
              style="margin-left:10px;"
              width="20"
              height="18"
              alt
            />
          </a>
          <div class="wx-box flexaj flexc" :style="isShow?'left:120px;':''" v-if="isWxShow">
            <img src="@/assets/images/home/weixin.jpg" alt />
            <p style="color:#666;margin-top: 10px;">{{$t("header.scanToFollow")}}</p>
          </div>
        </div>
        <div class="right flexa">
          <div class="lang">
            <span>{{$t("header.language")}}：</span>
            <select
              v-model="lang"
              name="lang"
              style="background: #474747;color:#fff;padding:2px 0px;"
            >
              <option value="cn" disabled="false">简体</option>
              <option value="tc">繁体</option>
              <option value="en" disabled="false">English</option>
              <!-- <option value="en" disabled>English</option> -->
            </select>
            <!-- <span class="pointer-underline" @click="changeLang">{{getLang}}</span> -->
          </div>
          <div class="list">
            <a
              class="item pipe pointer-underline"
              href="https://www.globalcash.cn/v4/login"
              target="_blank"
            >{{$t("common.signIn")}}</a>
            <a
              class="item pipe pointer-underline"
              href="https://www.globalcash.cn/v4/login"
              target="_blank"
            >{{$t("common.activate")}}</a>
            <span class="item pipe pointer-underline" @click="toRegister">{{$t("header.joinFree")}}</span>
            <span class="item pointer-underline" @click="toPartner">{{$t("header.coperation")}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import api from "../../utils/api";
import { aPost3 } from "../../utils/request";
export default {
  data() {
    return {
      //语言
      lang: "tc",
      //手机全球付
      isShow: false,
      //显示的控制
      isInnerDownload: false,
      //app 下载盒子
      isAppDownLoadShow: false,
      //微信二维码
      isWxShow: false,
      customer: "",
      isFinish: true
    };
  },
  methods: {
    toActivate() {
      window.location.href = `https://www.globalcash.cn/activate/codeActivate.jsp`;
    },
    toPartner() {
      window.location.href = `https://www.globalcash.cn/Businesscoop.html`;
    },
    toRegister() {
      window.location.href = `https://www.globalcash.cn/sign-reb.do`;
    },
    showAppDownload() {
      this.isAppDownLoadShow = true;
    },
    hideAppDownload() {
      setTimeout(() => {
        if (this.isInnerDownload) {
          return false;
        }
        this.isAppDownLoadShow = false;
      }, 300);
    }
  },
  watch: {
    lang() {
      this.$i18n.locale = this.lang;
    },
    $route(to) {
      to.name === "home" ? (this.isShow = false) : (this.isShow = true);
    }
  }
};
</script>
<style lang="scss" scoped>
.header {
  flex-shrink: 0;
  .top {
    width: 100%;
    background-color: #474747;
    height: 32px;
    .container {
      width: 960px;
      color: #fff;
      .left {
        position: relative;
        .mobile-globalcash {
          margin-right: 10px;
          position: relative;
          .appDownload-box {
            position: absolute;
            left: 0;
            bottom: -263px;
            width: 375px;
            height: 220px;
            z-index: 8888;
            background-color: #efefef;
            padding: 20px;
          }
        }
        .wx-box {
          position: absolute;
          left: 40px;
          top: 30px;
          width: 150px;
          height: 150px;
          z-index: 9999;
          background-color: #efefef;
          /* padding-top: 10px; */
        }
        /* img {
            margin-left: 10px;
          } */
      }
      .right {
        .lang {
          margin-right: 25px;
        }
        .list {
          .item {
            color: #fff;
            padding: 0 12px;
          }
          .pipe {
            position: relative;
          }
          .pipe::after {
            position: absolute;
            content: "|";
            top: 50%;
            right: -5px;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}
</style>